<main class="kebab-list-container">
  <!-- Rating Menu Item -->
  <section class="kebab-list-item rating-trigger" [class.is-open]="showStars" (click)="toggleStars($event)">
    <span class="icon-text">
      <lucide-icon name="star" size="14"></lucide-icon>
      <span>Rating</span>
    </span>
    <span class="rating-badge" *ngIf="selectedStar > 0">★</span>
    <lucide-icon
      [name]="showStars ? (openSide === 'left' ? 'chevron-left' : 'chevron-right') : (openSide === 'left' ? 'chevron-left' : 'chevron-right')"
      size="14"
      class="chevron-icon"
      [class.open]="showStars">
    </lucide-icon>
  </section>

  <!-- Cinematic Rating Sidebar (Pure Stars, No Numbers) -->
  <aside
    class="rating-sidebar"
    [class.side-left]="openSide === 'left'"
    [class.side-right]="openSide === 'right'"
    *ngIf="showStars"
    (click)="$event.stopPropagation()">

    <div class="rating-sidebar-header">
      <div class="rating-header-left">
        <lucide-icon name="sparkles" size="13" class="header-sparkle"></lucide-icon>
        <span class="rating-title">Rate Title</span>
      </div>
      <button type="button" class="sidebar-close-btn" (click)="toggleStars($event)" title="Close">&times;</button>
    </div>

    <!-- 5 Large Cinematic Glowing Stars -->
    <div class="stars-row" (mouseleave)="onLeave()">
      <button
        *ngFor="let s of stars"
        type="button"
        class="star-btn"
        [class.active]="s <= (hoveredStar || selectedStar)"
        (mouseenter)="onHoverStar(s)"
        (click)="rate(s, $event)"
        [title]="getStarLabel(s)">
        ★
      </button>
    </div>

    <!-- Feedback Text without numbers -->
    <div class="rating-feedback">
      <div class="rating-label-wrap" *ngIf="hoveredStar || selectedStar">
        <span class="rating-label-badge">{{ getStarLabel(hoveredStar || selectedStar) }}</span>
      </div>
      <span class="rating-hint" *ngIf="!hoveredStar && !selectedStar">
        Tap a star to rate
      </span>
    </div>
  </aside>
</main>
